import createGetFormValues from './selectors/getFormValues';
import plain from './structure/plain';
export default createGetFormValues(plain);


//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/redux-form/es/getFormValues.js
// module id = KrA1
// module chunks = 1